import { useTranslation } from 'react-i18next';

import FormattedCurrency from 'components/FormattedCurrency/FormattedCurrency';

interface DisplayPrizeCurrencyOrSuffixProps {
  value: number;
  currency: string;
  suffix?: string;
  prizeCode?: string;
  prizeMultiplier?: number;
}

const DisplayCurrencyOrPrizeSuffix = (props: DisplayPrizeCurrencyOrSuffixProps) => {
  const { t } = useTranslation();

  if (props.prizeCode === 'betcredit') {
    return (
      <span>
        <FormattedCurrency value={props.value} currency={props.currency} />
        {props.suffix ? ` ${t(props.suffix)}` : ''}
      </span>
    );
  }

  if (props.prizeCode === 'freespin') {
    return <>{props.suffix ? t(props.suffix, { amount: props.prizeMultiplier }) : ''}</>;
  }

  return <FormattedCurrency value={props.value} currency={props.currency} />;
};

export default DisplayCurrencyOrPrizeSuffix;
